import React from 'react'
import './index.scss'
interface DashboardNoDataInfoProps {
    type: string
    finalWord?: 'submitted' | 'available'
}

const DashboardNoDataInfo = ({ type, finalWord = 'available' }: DashboardNoDataInfoProps) => (
    <div className="no-data-info">
        <div>
            No <strong>{type}</strong> {finalWord}
        </div>
    </div>
)

export default DashboardNoDataInfo
